module.exports = __webpack_public_path__ + "static/img/testimony (84).e7cfeb74.jpg";